<div class="blocked">
    <h3>Queremos que estés seguro</h3>
    <p class="complete-transfer">
      Detectamos un comportamiento inusual en tu cuenta, por eso la hemos desactivado por el día de hoy.
    </p>
    <p class="complete-transfer">
      Si tienes alguna duda por favor contactate a shellbox&#64;raizen.com.ar
    </p>
    <button class="btn-confirm" (click)="close.emit()">
      Aceptar
    </button>
  </div>
  